import { render, staticRenderFns } from "./AdminAlert.vue?vue&type=template&id=234889b2&scoped=true&"
import script from "./AdminAlert.vue?vue&type=script&lang=js&"
export * from "./AdminAlert.vue?vue&type=script&lang=js&"
import style0 from "./AdminAlert.vue?vue&type=style&index=0&id=234889b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234889b2",
  null
  
)

export default component.exports